<template>
    <div class="__page">
        <div class="wrapper">
            <div :class="[
                { 'grid grid-space-20': isSample }
            ]">
                <CouponSample 
                    v-if="isSample"
                    :sample="couponSampling"
                />
                <CouponEmpty 
                    v-if="coupon === null || !coupon.pdf" 
                    :is-flex="isSample" 
                />
                <Coupon 
                    v-else 
                    :is-grid="!isSample"
                    :coupon="coupon"
                />
            </div>
            <Appbox />
        </div>
    </div>
</template>

<script>
import Appbox from '@/components/appbox/Appbox'
import Coupon from '@/components/coupon/Coupon'
import CouponEmpty from '@/components/coupon/CouponEmpty'
import CouponSample from '@/components/coupon/CouponSample'

export default {
    components: {
        Appbox,
        Coupon,
        CouponEmpty,
        CouponSample
    },

    computed: {
        coupon() {
            return this.$store.getters['coupon/coupon']
        },

        couponSampling() {
            return this.$store.getters['apiSample/sample']
        },

        isSample() {
            return this.couponSampling && this.couponSampling.consentStatus === true
        }
    },

    mounted() {
        this.$store.dispatch('steps/intendCoupon')
        this.$store.dispatch('apiSample/setSampleIsDone')

        let obj = {}

        obj = Object.assign({
            sampleId: this.$store.getters['apiSample/selectedSampleId']
        }, this.$store.getters['apiSample/sample'])

        window.localStorage.setItem('sample', JSON.stringify(obj))
        
        localStorage.setItem('isDone', 'isDone')
    }
}
</script>

<style>

</style>